<p-toast></p-toast>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="card pr-3">
    <div class="flex flex-row-reverse flex-wrap card-container">
    <div class="flex align-items-center justify-content-center m-2" *ngIf="treeData && treeData.length > 0">
      <p-button
        styleClass="p-button-outlined"
        icon="pi pi-history"
        id="scopeAuditTrailButton"
        (debounceClick)="viewScopeAuditTrail()"
        iconPos="left"
        pTooltip="Audit Trail"
        tooltipPosition="bottom"
        class="hierarchy-scope-button"
        [disabled]="!isAuditTrailButtonEnabled"
        appPreventDoubleClick>
      </p-button>
    </div>
     <div class="flex align-items-center justify-content-center m-2" *ngIf="scopeDetail?.isBulkUserUpdateButtonVisible">
      <p-button
        styleClass="p-button-outlined"
        icon="fa-solid fa-users"
        id="bulk-user-update"
        (debounceClick)="openBulkUserUpdateSlider()"
        iconPos="left"
        pTooltip="Bulk Add/Remove Users"
        tooltipPosition="bottom"
        [disabled]="!isEditButtonEnabled"
        appPreventDoubleClick>
      </p-button>
    </div>
    <div class="flex align-items-center justify-content-center m-2" *ngIf="scopeDetail?.isUpdateScopeHierarchyButtonVisible">
      <p-button
        styleClass="p-button-outlined"
        icon="fa-solid fa-folder-tree"
        id="hierarchyScopeButton"
        (debounceClick)="openHierarchySlider()"
        iconPos="left"
        pTooltip="Edit Scope Hierarchy"
        tooltipPosition="bottom"
        class="hierarchy-scope-button"
        appPreventDoubleClick>
      </p-button>
    </div>
    <div class="flex align-items-center justify-content-center m-2" *ngIf="scopeDetail?.isUpdateScopeButtonVisible">
      <p-button
        styleClass="p-button-outlined"
        icon="fa fa-pen"
        id="editScopeButton"
         (debounceClick)="editeQMSScope()"
        iconPos="left"
        pTooltip="Edit eQMS Scope"
        tooltipPosition="bottom"
        class="edit-scope-button"
        [disabled]="!isEditButtonEnabled"
        appPreventDoubleClick>
      </p-button>
    </div>
     <div class="flex align-items-center justify-content-center m-2" *ngIf="scopeDetail?.isCreateScopeButtonVisible">
      <p-button
       appPreventDoubleClick
        icon="fa fa-plus"
        id="addScopeButton"
        (debounceClick)="createeQMSScope()"
        iconPos="left"
        pTooltip="Add eQMS Scope"
        tooltipPosition="bottom"
        class="add-scope-button"    
      >
      </p-button>   
  </div>
   <div class="flex align-items-center m-2 mr-auto pl-3" *ngIf="treeData && treeData.length > 0">
    <p-button 
      icon="pi pi-plus" 
      label="Expand All"
      styleClass="p-button-sm p-button-text"
      (onClick)="expandAll()"
      pTooltip="Expand all nodes"
      tooltipPosition="top"
    ></p-button>
    <p-button 
      icon="pi pi-minus" 
      label="Collapse All"
      styleClass="p-button-sm p-button-text"
      (onClick)="collapseAll()"
      pTooltip="Collapse all nodes (root stays expanded)"
      tooltipPosition="top"
    ></p-button>
  </div>
 
  </div>
</div>

<app-scope-form-slider 
  *ngIf="iseQMSScopeSliderOpen" 
  [iseQMSScopeSliderOpen]="iseQMSScopeSliderOpen" 
  [isGlobalEqmsInstance]="scopeDetail?.isGlobalEqmsInstance ?? false" 
  [isOnlyScopeManager]="scopeDetail?.isOnlyScopeManager ?? false" 
  [selectedScope]="selectedScopeNode"
  [treeData]="treeData"
  [primaryScopeId]="scopeDetail?.primaryScopeId ?? 0"
  (iseQMSScopeSliderActive)="closeAndResetEQMSScopeSlider($event)"></app-scope-form-slider> 
<app-update-scope-hierarchy-slider *ngIf="isHierarchySliderOpen" 
        [isHierarchySliderOpen]="isHierarchySliderOpen"
        [treeData]="hierarchyTreeDataCopy"
        (isHierarchySliderActive)="closeAndResetHierarchySlider()"
        (hierarchyUpdated)="onHierarchyUpdated($event)"></app-update-scope-hierarchy-slider>

<app-scope-audit-modal 
  [isShowScopeAuditModal]="isShowScopeAuditModal"
  [auditData]="scopeAuditTrail"
  [scopeName]="scopeName"
  (closeModal)="closeScopeAuditModal($event)">
</app-scope-audit-modal>

<app-spinner *ngIf="isLoadingAfterHierarchyUpdate" message="Hierarchy update in progress.."></app-spinner>

<app-bulk-user-scope-slider 
  *ngIf="isBulkUserUpdateSliderOpen" 
  [isBulkUserUpdateSliderOpen]="isBulkUserUpdateSliderOpen"
  [selectedScope]="selectedScopeNode"
  (isBulkUserScopeSliderActive)="closeAndResetBulkUserScopeSlider()"
 ></app-bulk-user-scope-slider>

<div class="bpt-main-content-container tree-scrollable-container" *ngIf="accessToeQMSScope; else eQMSScopeNotFound">
  <app-tree class="eQMS-scope" id="" [treeData]="treeData" (onNodeSelection)="onScopeSelected($event)" (onNodeUnselection)="onScopeUnselected($event)"></app-tree>
</div>
<ng-template #eQMSScopeNotFound>
  <app-error [errorMessage]="eQMSScopeNotFoundErrorMessage()"></app-error>
</ng-template>
